import { useTheme } from '@emotion/react';
export default function useUITheme() {
  const theme = useTheme();
  return Object.keys(theme).length ? theme : undefined;
}